import './index.less'
export { default as Tabs } from './Tabs'
export { default as TabList } from './TabList'
export { default as Tab } from './Tab'
export { default as TabPanel } from './TabPanel'
